export enum RecordStateEnum {
  FINISHED = 'FINISHED',
  INVOICED = 'INVOICED',
  INVOICED_PENDING = 'INVOICED_PENDING',
  OPENED = 'OPENED'
}
